module.exports = __webpack_public_path__ + "static/media/mt.dcb55d42.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/mt.svg
// module id = 198
// module chunks = 0